<template>
  <el-form
    v-if="model"
    v-loading="saveLoading"
    :label-position="labelPosition"
    :label-width="labelWidthForm"
    :model="model"
    :rules="rules"
    @submit.native.prevent="doSubmit"
    class="form subprogram-form"
    ref="form"
  >
    <el-steps v-if="showSteps" :active="activeStepIndex" align-center finish-status="success">
      <el-step :title="i18n('entities.subprogram.form.subtitle.information')" />
      <el-step
        v-if="!isStripeDisabled"
        :title="i18n('entities.subprogram.form.subtitle.paymentActivity')"
      />
      <el-step :title="i18n('entities.subprogram.form.subtitle.moreInformation')" />
    </el-steps>

    <!-- Step 1 -->
    <template v-if="isActiveStep1">
      <h2 class="app-content-subtitle">
        <app-i18n code="entities.subprogram.form.subtitle.information" />
      </h2>

      <el-row :gutter="10">
        <!-- Id -->
        <el-col :lg="12" :md="16" :sm="24">
          <el-form-item :label="fields.id.label" :prop="fields.id.name" v-if="isEditing">
            <el-input :disabled="true" v-model="model[fields.id.name]" />
          </el-form-item>
        </el-col>

        <!-- Name -->
        <el-col :lg="12" :md="12" :sm="24">
          <el-form-item
            v-if="isCampClinicProgram"
            :label="fields.name.label"
            :prop="fields.name.name"
            :required="fields.name.required"
          >
            <el-input
              v-model="model[fields.name.name]"
              :placeholder="i18n(`entities.subprogram.placeholders.${fields.name.name}`)"
            >
              <i slot="prefix" class="icon-cup" />
            </el-input>
          </el-form-item>
        </el-col>

        <!-- Category -->
        <el-col :lg="6" :md="6" :sm="24">
          <el-form-item
            :label="fields.category.label"
            :prop="fields.category.name"
            :required="fields.category.required"
          >
            <app-autocomplete-one-input
              :fetchFn="fields.category.fetchFn"
              v-model="model[fields.category.name]"
              :placeholder="i18n(`entities.subprogram.placeholders.${fields.category.name}`)"
              prefix-icon="icon-cup"
            ></app-autocomplete-one-input>
          </el-form-item>
        </el-col>

        <!-- Gender -->
        <el-col :lg="6" :md="6" :sm="24">
          <el-form-item
            :label="fields.gender.label"
            :prop="fields.gender.name"
            :required="fields.gender.required"
          >
            <el-select
              v-model="model[fields.gender.name]"
              :placeholder="i18n(`entities.subprogram.placeholders.${fields.gender.name}`)"
            >
              <i slot="prefix" class="icon-player" />
              <el-option
                :key="option.id"
                :label="option.label"
                :value="option.id"
                v-for="option in fields.gender.options"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- Date Range -->
        <!-- <el-col :lg="12" :md="12" :sm="24">
          <el-form-item
            :label="fields.dateRange.label" 
            :prop="fields.dateRange.name" 
            :required="true"
          >
            <el-date-picker
              v-model="model[fields.dateRange.name]"
              type="daterange"
              :format="i18n('common.date.formatInput')"
              :start-placeholder="i18n('common.date.formatInput')"
              :end-placeholder="i18n('common.date.formatInput')"
            />
          </el-form-item>
        </el-col>-->

        <!-- Dates -->
        <app-date-range
          :startLabel="fields.startDate.label"
          :endLabel="fields.endDate.label"
          :startDate.sync="model[fields.startDate.name]"
          :endDate.sync="model[fields.endDate.name]"
          :startPlaceholder="i18n('common.date.formatInput').toLowerCase()"
          :endPlaceholder="i18n('common.date.formatInput').toLowerCase()"
          :startFormat="dateFormat"
          :endFormat="dateFormat"
          ref="dateRange"
        />
      </el-row>

      <!-- Separator -->
      <div class="app-content-separator" />

      <h2 class="app-content-subtitle">
        <app-i18n :code="isPropertyNBA ? 'entities.subprogram.nba.rounds.label' : 'entities.subprogram.form.subtitle.moreInformation'" />
      </h2>

      <el-row :gutter="10">
        <!-- Gender -->
        <!-- <el-col :lg="10" :md="10" :sm="24">
          <el-form-item
            :label="fields.gender.label"
            :prop="fields.gender.name"
            :required="fields.gender.required"
          >
            <el-select
              v-model="model[fields.gender.name]"
              :placeholder="i18n(`entities.subprogram.placeholders.${fields.gender.name}`)"
            >
              <i slot="prefix" class="icon-player" />
              <el-option
                :key="option.id"
                :label="option.label"
                :value="option.id"
                v-for="option in fields.gender.options"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->

        <!-- Rounds -->
        <el-col :lg="10" :md="10" :sm="24">
          <el-form-item
            v-if="isPropertyNBA"
            :label="fields.regularSeasonHasRounds.label"
            :prop="fields.regularSeasonHasRounds.name"
            :required="fields.regularSeasonHasRounds.required"
          >
            <el-radio-group
              v-model="model[fields.regularSeasonHasRounds.name]"
              :disabled="isRegularSeasonConfigured"
            >
              <el-radio :label="true">
                <app-i18n code="common.yes" />
              </el-radio>
              <el-radio :label="false">
                <app-i18n code="common.no" />
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <!-- Locations -->
        <el-col :lg="10" :md="10" :sm="24">
          <el-form-item
            v-if="!isLeagueProgram"
            :label="fields.locations.label"
            :prop="fields.locations.name"
            :required="fields.locations.required"
          >
            <app-autocomplete-many-input
              :fetchFn="fields.locations.fetchFn"
              v-model="model[fields.locations.name]"
              :placeholder="i18n(`entities.subprogram.placeholders.${fields.locations.name}`)"
              prefix-icon="icon-location"
            ></app-autocomplete-many-input>
          </el-form-item>
        </el-col>
      </el-row>
    </template>

    <!-- Step 2 -->
    <template v-if="!isLeagueProgram && (isActiveStep2)">
      <el-row :gutter="10">
        <!-- Payment -->
        <el-col :lg="24" :md="24" :sm="24">
          <subprogram-payment-input
            v-if="!isStripeDisabled"
            :subpropertyId="subpropertyId"
            :payment.sync="model[fields.payment.name]"
            :subprogram-status="model[fields.status.name]"
            :manage="manage"
            ref="paymentForm"
          />
        </el-col>
      </el-row>
    </template>

    <!-- Step 3 -->
    <template v-if="!isLeagueProgram && ( isActiveStep3 )">
      <h2 class="app-content-subtitle">
        <app-i18n code="entities.subprogram.form.subtitle.tryout" />
      </h2>

      <!-- Tryout -->
      <el-row :gutter="10">
        <el-col :lg="24" :md="24" :sm="24">
          <subprogram-tryout-input :tryout.sync="model[fields.tryout.name]" ref="tryoutForm" />
        </el-col>
      </el-row>

      <h2 class="app-content-subtitle">
        <app-i18n code="entities.subprogram.form.subtitle.competitionLeague" />
      </h2>

      <!-- Competitions  -->
      <el-row :gutter="10">
        <el-col :lg="12" :md="12" :sm="24">
          <el-form-item
            :label="fields.competitions.label"
            :prop="fields.competitions.name"
            :required="fields.competitions.required"
          >
            <strings-input
              v-model="model[fields.competitions.name]"
              btnI18nCode="entities.subprogram.fields.competitions.btn"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <h2 class="app-content-subtitle">
        <app-i18n code="entities.subprogram.form.subtitle.requiredDocuments" />
      </h2>

      <!-- Iddentity needed -->
      <el-row :gutter="10">
        <el-col :lg="12" :md="16" :sm="24">
          <el-form-item class="el-form-item--radio" :prop="fields.identDocNeeded.name" required>
            <span v-text="fields.identDocNeeded.label" />
            <el-radio-group v-model="model[fields.identDocNeeded.name]">
              <el-radio :label="true">
                <app-i18n code="common.yes" />
              </el-radio>
              <el-radio :label="false">
                <app-i18n code="common.no" />
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <!-- Additional doc -->
        <el-col :lg="24" :md="24" :sm="24">
          <subprogram-additional-doc-input
            :additionalDoc.sync="model[fields.additionalDoc.name]"
            :subpropertyId="subpropertyId"
            :programId="programId"
            :subprogramId="id"
            ref="additionalDocForm"
          />
        </el-col>

        <!-- Status -->
        <el-col :lg="12" :md="16" :sm="24">
          <el-form-item
            :label="fields.status.label"
            :prop="fields.status.name"
            :required="fields.status.required"
            v-if="isEditing"
          >
            <el-col :lg="12" :md="16" :sm="24">
              <el-select placeholder v-model="model[fields.status.name]">
                <el-option
                  v-for="option in fields.status.options"
                  v-show="option.id !== 'draft'"
                  :key="option.id"
                  :label="option.label"
                  :value="option.id"
                />
              </el-select>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
    </template>

    <!-- Form controls -->
    <el-form-item>
      <div class="form-buttons form-buttons--sides">
        <!-- Back button -->
        <el-button :disabled="saveLoading" @click="doBack" type="secondary">
          <app-i18n code="common.backButton" />
        </el-button>

        <!-- Create account button -->
        <el-row :gutter="20" v-if="!isEditing && isActiveStep3">
          <!-- Save as publish button -->
          <el-col :lg="12" :md="12" :sm="12">
            <el-button
              :disabled="saveLoading"
              @click="doSubmitAsPublish()"
              icon="el-icon-fa-floppy-o"
              type="primary"
            >
              <app-i18n code="entities.subprogram.form.btnSubmit.asPublish"></app-i18n>
            </el-button>
          </el-col>

          <!-- Save as draft button -->
          <el-col :lg="12" :md="12" :sm="12">
            <el-button
              :disabled="saveLoading"
              @click="doSubmitAsDraft()"
              icon="el-icon-fa-floppy-o"
              type="primary"
            >
              <app-i18n code="entities.subprogram.form.btnSubmit.asDraft"></app-i18n>
            </el-button>
          </el-col>
        </el-row>

        <el-row :gutter="10" v-else-if="isActiveStep3 || isLeagueProgram">
          <!-- Save as Status -->
          <el-col :lg="12" :md="12" :sm="12">
            <el-button :disabled="saveLoading" @click="doSubmit" type="primary">
              <app-i18n v-if="!isEditing" code="common.create" />
              <app-i18n v-else code="common.save" />
            </el-button>
          </el-col>
        </el-row>

        <!-- Continue button -->
        <el-button v-else :disabled="saveLoading" @click="doContinue" type="primary">
          <app-i18n code="common.continue" />
        </el-button>
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { SubprogramModel } from '@modules/subprogram/subprogram-model';
import { i18n } from '@shared/i18n';
import SubprogramPaymentInput from '@modules/subprogram/components/subprogram-payment-input';
import SubprogramTryoutInput from '@modules/subprogram/components/subprogram-tryout-input';
import SubprogramAdditionalDocInput from '@modules/subprogram/components/subprogram-additional-doc-input';
import _ from 'underscore';
import {get} from 'lodash';
import 'fix-date';

export default {
  name: 'SubprogramForm',

  props: {
    id: {
      type: String,
    },
    propertyId: String,
    subpropertyId: String,
    programId: String,
    programType: String,
  },

  data() {
    return {
      subprogramId: null,
      model: null,
      visible: true,
      activeStepIndex: 0,
    };
  },

  computed: {
    ...mapGetters({
      currentManage: 'auth/manage/currentManage',
      dateFormat: 'auth/manage/dateFormat',
      populateDate: 'auth/manage/populateDate',
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'subprogram/form/record',
      findLoading: 'subprogram/form/findLoading',
      saveLoading: 'subprogram/form/saveLoading',
      isRootScreen: 'layout/isRootScreen',
      isPropertyNBA: 'auth/manage/isPropertyNBA',
    }),
    isEditing() {
      return !!this.id;
    },
    rules() {
      const { formSchema } = this;
      return formSchema.rules();
    },
    formSchema() {
      const { fields } = this;
      return new FormSchema([
        fields.id,
        fields.name,
        fields.category,
        fields.startDate,
        fields.endDate,
        fields.dateRange,
        fields.gender,
        fields.locations,
        fields.emails,
        fields.status,
        fields.payment,
        fields.tryout,
        fields.additionalDoc,
        fields.identDocNeeded,
        fields.competitions,
        fields.regularSeasonHasRounds,
      ]);
    },
    fields() {
      const { dateFormat} = this;
      return new SubprogramModel({
        dateFormat,
      }).fields();
    },
    manage() {
      return {
        type: 'program',
        property: { id: this.propertyId },
        subproperty: { id: this.subpropertyId },
        program: {
          id: this.programId,
          type: this.programType,
        },
      };
    },
    isCampClinicProgram() {
      return this.programType === 'campclinics';
    },
    isClubProgram() {
      return this.programType === 'club';
    },
    isSchoolProgram() {
      return this.programType === 'school';
    },
    isLeagueProgram() {
      return this.programType === 'league';
    },
    nameSubprogram() {
      if (
        this.model.category &&
        this.model.category.label &&
        this.isClubProgram
      ) {
        return this.model.category.label;
      }
      return '';
    },
    isStripeDisabled() {
      if (!this.currentManage) return true;
      if (!('subproperty' in this.currentManage))
        return true;
      if (
        !(
          'paymentsEnabled' in
          this.currentManage.subproperty
        )
      )
        return true;
      return !this.currentManage.subproperty
        .paymentsEnabled;
    },
    isActiveStep1() {
      return this.activeStepIndex == 0;
    },
    isActiveStep2() {
      if (this.isStripeDisabled) {
        return false;
      }
      return this.activeStepIndex == 1;
    },
    isActiveStep3() {
      if (this.isStripeDisabled) {
        return this.activeStepIndex == 1;
      }
      return this.activeStepIndex == 2;
    },
    showSteps() {
      return !(this.isLeagueProgram);
    },
    isRegularSeasonConfigured() {
      return get(this, 'record.regularSeasonConfigured', false);
    }
  },

  async created() {
    const { formSchema } = this;

    if (this.isEditing) {
      this.subprogramId = this.id;
      await this.doFind({
        id: this.id,
        propertyId: this.propertyId,
        subpropertyId: this.subpropertyId,
        programId: this.programId,
      });
    } else {
      this.subprogramId = await this.doGetNewId({
        subpropertyId: this.subpropertyId,
        programId: this.programId,
      });
      await this.doNew();
    }

    this.model = formSchema.initialValues(this.record);
  },

  methods: {
    ...mapActions({
      doGetNewId: 'subprogram/form/doGetNewId',
      doFind: 'subprogram/form/doFind',
      doNew: 'subprogram/form/doNew',
      doUpdate: 'subprogram/form/doUpdate',
      doCreate: 'subprogram/form/doCreate',
    }),

    doBack() {
      if (this.activeStepIndex === 0) {
        // TODO: Check if there's router history
        if (this.isRootScreen)
          this.$router.push({ name: 'programList' });
        else this.$router.go(-1);
        // - if so, go back
        // - otherwise, go back to Dashboard
      } else {
        this.activeStepIndex--;
      }
    },

    async doContinue() {
      try {
        await this.doValidation();
        this.activeStepIndex++;
      } catch (error) {
        return;
      }
    },

    async doValidation() {
      try {
        const {
          form,
          paymentForm,
          tryoutForm,
          dateRange,
          additionalDocForm,
        } = this.$refs;
        const forms = [];

        if (form) forms.push(form);
        if (paymentForm) forms.push(paymentForm.$refs.form);
        if (dateRange) forms.push(dateRange.$refs.form);

        if (tryoutForm) {
          forms.push(tryoutForm.$refs.form);
          const { dateRangeTryout } = tryoutForm.$refs;

          if (dateRangeTryout) {
            const sizeForms = _.size(
              dateRangeTryout.$refs.form,
            );

            if (sizeForms > 0) {
              forms.push(dateRangeTryout.$refs.form);
            }
          }
        }

        if (additionalDocForm) {
          forms.push(additionalDocForm.$refs.form);
          const {
            uploadDocsForm,
          } = additionalDocForm.$refs;

          if (uploadDocsForm) {
            const sizeForms = _.size(
              uploadDocsForm.$refs.form,
            );

            if (sizeForms > 0) {
              forms.push(...uploadDocsForm.$refs.form);
            }
          }
        }

        await Promise.all(
          forms.map((form) => {
            form.clearValidate();
            return form.validate();
          }),
        );
        return; //
      } catch (error) {
        throw error;
      }
    },

    doReset() {
      const { formSchema } = this;
      this.model = formSchema.initialValues(this.record);
    },

    async doSubmitAsPublish() {
      this.model.status = 'published';
      this.doSubmit();
    },

    async doSubmitAsDraft() {
      this.model.status = 'draft';
      this.doSubmit();
    },

    async doSubmit() {
      const { formSchema } = this;
      try {
        await this.doValidation();

        if (!this.isLeagueProgram) {
          this.activeStepIndex++;
        }
      } catch (error) {
        console.log('Error: ', error);
        return;
      }

      const { id, ...values } = formSchema.cast(this.model);

      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
          propertyId: this.propertyId,
          subpropertyId: this.subpropertyId,
          programId: this.programId,
          // manage: this.manage,
        });
      } else {
        return this.doCreate({
          id: this.subprogramId,
          values,
          propertyId: this.propertyId,
          subpropertyId: this.subpropertyId,
          programId: this.programId,
          // manage: this.manage,
        });
      }
    },

    handleCLoseModal() {
      this.$router.go(-1);
    },

    i18n(code) {
      return i18n(code);
    },
  },

  watch: {
    'model.category.label'(newVal) {
      if (
        this.isClubProgram ||
        this.isSchoolProgram ||
        this.isLeagueProgram
      ) {
        this.model.name = newVal;
      }
    },
  },
  components: {
    SubprogramPaymentInput,
    SubprogramTryoutInput,
    SubprogramAdditionalDocInput,
  },
};
</script>


<style>
.subprogram-form .el-radio-group{
  margin-left: 16px !important;
}
</style>
